// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1OS0e","bigColWidth":"Table_bigColWidth__29I-v","biggerColWidth":"Table_biggerColWidth__3vSAN","row":"Table_row__3cBz6","col":"Table_col__3uBdg"};